export default "__VITE_ASSET__CaVj1mMT__"